// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3gXe7","col":"styles_col__3FYjf"};